import mainRefs from "@/__main__/refs.mjs";
import { GAME_ACTIVE_MAP } from "@/app/constants.mjs";
import type { GameSymbol } from "@/app/games.mjs";
import globals from "@/util/global-whitelist.mjs";
import type SymbolMap from "@/util/symbol-map.mjs";

// These both should be hardcoded in the page.
export const appSelector = "#blitz-app";
export const appContainer: HTMLElement | null =
  globals.document?.querySelector(appSelector);

// Used for scoping CSS. This one is not unique!
export const internalContainerClass = "blitz-app-style";

// Used for injecting into the app. This one is unique and only refers
// to the actual app! And a little randomness to prevent hardcoding.
export const INTERNAL_CONTAINER_ID = `blitz-app-${mainRefs.PKG_VERSION}`;

export const getInternalContainer: () => HTMLElement | null = () =>
  globals.document?.getElementById(INTERNAL_CONTAINER_ID);

// Omit loading animation from result.
export const hasMarkup = Boolean(
  Array.prototype.filter.call(
    appContainer?.children ?? [],
    (element: HTMLElement) => element.id !== "blitz-loading",
  ).length,
);

export const winRateColors = {
  wrBinaryBad: "#FF5859",
  wrBinaryGood: "#49B4FF",
  wr46Less: "#FF5859",
  wr46to47: "#F16F74",
  wr47to48: "#E4858F",
  wr48to49: "#D69CAA",
  wr49to50: "#C9B2C5",
  wr50: "var(--shade1)",
  wr50to51: "#A4C5E6",
  wr51to52: "#8DC1EC",
  wr52to53: "#77BCF3",
  wr53to54: "#60B8F9",
  wr54Plus: "#49B4FF",
};

export const deleteInactiveGames = (
  obj: SymbolMap<Record<keyof typeof GAME_ACTIVE_MAP, unknown>>,
) => {
  for (const [key] of obj) if (GAME_ACTIVE_MAP[key] !== true) delete obj[key];
  return obj;
};
